import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface ToggleButtonGroupCSSStyle extends UIComponentCSSStyle
{
  getTabHeaderCSSStyle(): object; 
}

export class ToggleButtonGroupCSSStyleImpl extends UIComponentCSSStyleImpl implements ToggleButtonGroupCSSStyle 
{ 
  getTabHeaderCSSStyle(): object 
  {
      return {
          // height: "40px",
          // width: "100%",
          boxSizing: "border-box",
          backgroundColor: "#ffffff",
          // display: "flex",
          // border: "none",
          // position: "relative",
          // flexDirection: "row",
          // flexFlow: "row wrap",
          // overflow:"auto"
      };
  }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebuttongroup/togglebuttongroupcss.tsx